const s = "af.filter-sidebar.filter-toggled", t = class t extends CustomEvent {
  constructor(a) {
    super(s, { detail: { filterKey: a }, bubbles: !0, composed: !0 });
  }
};
t.EVENT_NAME = s;
let e = t;
export {
  s as EVENT_NAME,
  e as default
};
//# sourceMappingURL=FilterToggleEvent.js.map
